<template>
  <div class="section text-center">
    <div class="container-fluid">
      <div class="text-left">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/panel/settings?active=projects' }">Proyectos</el-breadcrumb-item>
            <el-breadcrumb-item>{{modeForm}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="col-md-8 ml-auto mr-auto">
        <div class="card plain">
          <div class="card-body">
            <el-form ref="formProject" :model="formProject" :rules="rules" v-loading="loading">
              <div class="title text-left">
                <h5><strong> {{$t('projects.info_title')}} </strong></h5>
              </div>
              <div class="row">
                  <div class="col-md-12">
                    <el-form-item prop="name" :label="$t('projects.name')" required>
                      <el-input
                        class=""
                        v-model="formProject.name"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <div class="datepicker-container">
                        <el-form-item prop="start_at" :label="$t('projects.date_start')" required>
                          <el-date-picker
                            type="date"
                            format="dd-MM-yyyy"
                            popper-class="date-picker"
                            placeholder="dd/mm/yyyy"
                            v-model="formProject.start_at"
                            style="width: 100%;">
                          >
                          </el-date-picker>
                        </el-form-item>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="datepicker-container">
                          <el-form-item prop="start_at" :label="$t('projects.date_end')" required>
                            <el-date-picker
                              type="date"
                              format="dd-MM-yyyy"
                              popper-class="date-picker"
                              placeholder="dd/mm/yyyy"
                              v-model="formProject.end_at"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </div>
                  </div>
              </div>
              <div class="row p-2">
                <div class="col-md-12">
                    <el-form-item prop="summary" :label="$t('projects.summary')">
                        <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="Summary"
                        v-model="formProject.summary">
                        </el-input>
                    </el-form-item>
                  </div>
              </div>
              <div class="row p-2">
                  <div class="col-md-6">
                    <el-form-item :label="$t('projects.ammount_total')" required>
                      <money 
                        v-bind="money"
                        v-model="formProject.ammount_total"
                        class="el-input__inner input-with-select"
                        >
                      </money>
                    </el-form-item>
                  </div>
                  <div class="col-md-6 text-center">
                  </div>
              </div>

              <el-collapse accordion>
                <el-collapse-item>
                    <template slot="title">
                      <h4><strong>{{$t('projects.ammount_investment')}}</strong></h4>
                    </template>
                    <div class="text-center">
                      <ammount-form 
                          :project-id="id" 
                          :table-data="ammounts" 
                          v-on:changed="handleAmmount" 
                      ></ammount-form>
                    </div>
                </el-collapse-item>

                <el-collapse-item>
                  <template slot="title">
                    <h4><strong> {{$t('projects.media_title')}} </strong></h4>
                  </template>
                  <upload-form :files="formProject.thumbnails" type="image" @inputadd="(ids) => { filesnew = ids }" @inputdel="(ids) => { filesdeleted = ids }"></upload-form>
                </el-collapse-item>


                <el-collapse-item>
                  <template slot="title">
                    <h4><strong>{{$t('projects.documents')}}</strong></h4>
                  </template>
                  <div class="text-center">
                    <upload-form 
                    :files="formProject.documents" 
                    type="prospect" 
                    @inputadd="(ids) => { filesnew = ids }" 
                    @inputdel="(ids) => { filesdeleted = ids }"
                    ></upload-form>
                  </div>
                </el-collapse-item>
              </el-collapse>

              <div class="card-footer text-center">
                  <router-link
                      class="btn text-white btn-round btn-default"
                      to="/panel/settings?active=projects">
                      {{$t('settings.button_cancel')}}
                  </router-link>
                  &nbsp;
                  <el-button size="medium" type="info" round  @click="onProjectSubmit('formProject')">
                    {{$t('settings.button_save')}}
                  </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Alert, Switch, Checkbox, Pagination } from '@/components';
import { DatePicker, Breadcrumb, BreadcrumbItem, Divider,
 Form, FormItem, Input, Upload, Button, MessageBox, Message, Select, Option,
 Collapse, CollapseItem } from 'element-ui';
import _ from 'lodash'
import AmmountForm from '../../pages/components/AmmountForm';
import UploadForm from '../../pages/components/UploadForm';
import {Money} from 'v-money'
import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
  name: 'project-form',
  components: {
    Card,
    [Button.name]: Button,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox,  
    [Switch.name]: Switch,
    Alert,
    [DatePicker.name]: DatePicker,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Upload.name]: Upload,
    [Pagination.name]: Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    AmmountForm,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    UploadForm,
    Money
  },
  data() {
    return {
        id: this.$route.params.id,
        loading: false,
        formProject: {
          name: null,
          start_at: null,
          end_at: null,
          summary: null,
          ammount_total: 0,
          stage_id: 1,
          thumbnails: [],
          documents: []
        },
        rules: {
          name: [{ required: true, message: 'Campo requerido', trigger: 'blur' }],
          start_at: [{ required: true, message: 'Campo requerido', trigger: 'blur' }],
          end_at: [{ required: true, message: 'Campo requerido', trigger: 'blur' }],
          ammount_total: [{ required: true, message: 'Campo requerido', trigger: 'blur' }]
        },
        filesnew: [],
        filesdeleted: [],
        stages: [],
        ammounts: [],
        modeForm: 'New',
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: false
        }
    }
  },
  mounted() {
    this.getProject()
    // this.getStages()
  },
  computed: {
    header () {
      return {
        Authorization: this.$store.state.token
      }
    }
  },
  methods: {
    onProjectSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let payload = _.cloneDeep(this.formProject)
          delete payload.thumbnails
          delete payload.documents
          payload.filesdeleted = this.filesdeleted
          payload.filesnew = this.filesnew
          payload.ammounts = this.ammounts

          console.info('save-> ', payload)

          if (this.id) {
            console.info(JSON.stringify(payload))
            provider.patchProject(this.id, payload).then((response) => {
              this.error = null
              Message({
                type: 'success',
                message: 'Operación exitosa'
              })
              setTimeout(() => {
                  this.loading = false
                  this.$router.push('/panel/settings?active=projects')
              }, 3000);
            }).catch((err) => {
              console.info('error post projects request')
              console.info(err)
            })
          } else {
            provider.postProject(payload).then((response) => {
              this.error = null
              Message({
                type: 'success',
                message: 'Operación exitosa'
              })
              setTimeout(() => {
                  this.loading = false
                  this.$router.push('/panel/settings?active=projects')
              }, 3000);
            }).catch((err) => {
              Message({
                type: 'warning',
                message: 'No se guardó la información, intente nuevamente'
              })
              this.loading = false
              console.info('error post projects request')
              console.info(err)
            })
          }
        } else {
          return false;
        }
      })
    },
    getProject() {
      if (this.$route.params && this.$route.params.id) {
        this.modeForm = 'Edit'
        let id = this.$route.params.id
        provider.getProject(id).then((response) => {
          console.info('get project response')
          let data = response.data.data
          if(data && data.attributes) {
            this.formProject.id = data.id
            this.formProject.name = data.attributes.name
            this.formProject.start_at = data.attributes.start_at
            this.formProject.end_at = data.attributes.end_at
            this.formProject.ammount_total = Number(data.attributes.ammount_total).toFixed(2)
            this.formProject.summary = data.attributes.summary
            this.formProject.stage_id = data.attributes.stage_id
            let thumbnails = []
            let files = []
            for (let index = 0; index < data.attributes.thumbnails.length; index++) {
              const t = data.attributes.thumbnails[index];
              let url = this.$store.state.api_files + t.id
              thumbnails.push({"name": t.id, "url": url, "internal_id": t.id})
            }
            for (let index = 0; index < data.attributes.documents.length; index++) {
              const t = data.attributes.documents[index];
              let url = this.$store.state.api_files + t.id
              files.push({"name": t.name, "url": url, "internal_id": t.id})
            }
            this.formProject.thumbnails = thumbnails
            this.formProject.documents = files
            this.ammounts = data.attributes.ammounts_investment
          }
        }).catch((err) => {
          console.info('error get project request')
          console.info(err)
        })
      }else {
        this.modeForm = 'New'
      }
    },
    getStages() {
      provider.getData('stages', 50, 1).then((response) => {
        let data = response.data.data
        this.stages = data
      }).catch((err) => {
        console.info(err)
      })
    },
    handleFileSuccess (res, file) {
      this.formProject.filesnew.push(file.response.id)
    },
    handleBeforeRemove(file, list){
      return MessageBox.confirm(`Esto eliminará permanentemente el archivo ${file.name}. ¿Continuar ?`,
      "Confirmation",
      {
        confirmButtonText: "Si",
        cancelButtonText: "No",
        type: "warning"
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    handleFileRemove(file, fileList) {
      if(this.filesdeleted && this.filesdeleted.length > 0)
      {
        this.filesdeleted.push({
          id: file.internal_id
        })
      } else {
        this.filesdeleted = [{
          id: file.internal_id
        }]
      }
    },
    handleAmmount(data){
      this.ammounts = data
    }
  },
  watch: {
  }
};
</script>
<style>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .v-money {
    width: 250px;
  }
</style>